export const Crash = () => {
	throw Error("Simulated crash")
}
